import type { ReactNode } from "react";
import { ComparisonModeProvider, useComparisonModeContext } from "@acto/taskpane/core/contexts/TenantSettingsContext";
import { comparisonModeFor, type PeriodSelection } from "@acto/taskpane/field-sales-2/utils/periodSelection";

interface PeriodComparisonScopeProps {
  selection: PeriodSelection;
  children: ReactNode;
}

export function PeriodComparisonScope({ selection, children }: PeriodComparisonScopeProps) {
  const tenantMode = useComparisonModeContext();

  return <ComparisonModeProvider value={comparisonModeFor(selection, tenantMode)}>{children}</ComparisonModeProvider>;
}
